import React from 'react';
import { CLUB } from '../../utils/constants';

/**
 * Das Club-Logo: das originale Rallye-Schild aus `pictures/Logo.png`,
 * aufbereitet nach `public/img/logo-*.png`.
 *
 * Am Original wurde nur der weiße Hintergrund entfernt - Farben und Formen
 * sind unverändert. Das Schild ist schwarz mit weißer Fassung und weißer
 * Schrift, die Schildfläche zeigt also unseren Seitenhintergrund. Deshalb
 * gibt es KEINE zweite Fassung für helle Untergründe: auf Weiss wäre von
 * der weißen Schrift nichts mehr zu sehen. Sollte je ein heller Bereich
 * dazukommen, dort das unverändertes Original aus `pictures/` verwenden.
 */
export default function Logo({ className = '' }) {
  return (
    <span className={`mt-logo ${className}`.trim()}>
      <img
        className="mt-logo__mark"
        src="/img/logo-360.png"
        srcSet="/img/logo-360.png 360w, /img/logo-688.png 688w"
        sizes="172px"
        width="688"
        height="308"
        alt={CLUB.name}
      />
    </span>
  );
}
